module.exports = "/assets/data/fdb3bf706de03c34794abca5f30f3947-HP20.data.json";